'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { IdpHeader } from './_layout/-components/IdpHeader';
export const Route = createFileRoute('/_staff/idp/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0 h-full">
      <IdpHeader />
      <div className="relative min-h-0 flex-1 overflow-auto bg-neutral-gray-light-2">
        <Outlet />
      </div>
    </VStack>;
}